import { supabase } from '../supabaseClient';
import { listQueue, removeById, isOnline } from './offlineQueue';

let processing = false;

const processors = {
  async save_calculation(payload) {
    const { error } = await supabase
      .from('calculations_23813')
      .insert([payload]);
    if (error) throw error;
  },
  async update_meta(payload) {
    const { id, patch } = payload || {};
    if (!id) throw new Error('missing id');
    const { data, error } = await supabase
      .from('calculations_23813')
      .update(patch)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  async delete_calculation(payload) {
    const { id } = payload || {};
    if (!id) throw new Error('missing id');
    const { error } = await supabase
      .from('calculations_23813')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

export const processOfflineQueue = async () => {
  if (processing) return;
  if (!isOnline()) return;
  processing = true;
  try {
    const tasks = listQueue();
    for (const item of tasks) {
      const fn = processors[item.type];
      if (!fn) {
        // 未知任务，直接丢弃
        removeById(item.id);
        continue;
      }
      try {
        await fn(item.payload);
        removeById(item.id);
      } catch (err) {
        // 保留队列项，稍后重试
      }
    }
  } finally {
    processing = false;
  }
};

export const initOnlineSync = () => {
  try {
    window.addEventListener('online', () => {
      processOfflineQueue();
    });
  } catch (_) {}
  // 应用启动及路由切换时可主动触发一次
  processOfflineQueue();
};